//CASL
export * from './casl';

// Domain model — frontend-safe surface. NEVER export repositories, drizzle
// tables or Node/Workers config here: persistence is a subpath-only barrel
// (./persistence) and config lives behind the `@scalified-monorepo/sample-shared/config`
// subpath (mirrors the generic repo's frontend-safe root barrel).
export * from './domain';
